var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "news-stat-v3" },
    [
      _c("div", { staticClass: "stat-section-header" }, [
        _vm._m(0),
        _vm.overview
          ? _c("div", { staticClass: "header-badge-group" }, [
              _c("span", { staticClass: "live-indicator" }, [
                _c("span", { staticClass: "pulse-dot" }),
                _vm._v(
                  " Tin đang hiển thị, tạo trong tháng: " +
                    _vm._s(_vm.overview.monthCount) +
                    " tin\n      "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm.overviewError
        ? _c("el-alert", {
            staticClass: "news-api-alert",
            attrs: {
              title: _vm.overviewError,
              type: "error",
              "show-icon": "",
              closable: false,
            },
          })
        : _vm._e(),
      _vm.overview
        ? _c("div", { staticClass: "news-kpi-grid" }, [
            _c("div", { staticClass: "news-kpi-card border-indigo" }, [
              _vm._m(1),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Tin tạo hôm nay"),
                ]),
                _c("div", { staticClass: "kpi-number text-indigo" }, [
                  _vm._v(_vm._s(_vm.overview.todayCount) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("tin")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(_vm._s(_vm.deltaLabel)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "news-kpi-card border-blue" }, [
              _vm._m(2),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Tin tạo tuần này"),
                ]),
                _c("div", { staticClass: "kpi-number text-blue" }, [
                  _vm._v(_vm._s(_vm.overview.weekCount) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("tin")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(_vm._s(_vm.weekLabel)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "news-kpi-card border-teal" }, [
              _vm._m(3),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Tin tạo tháng này"),
                ]),
                _c("div", { staticClass: "kpi-number text-teal" }, [
                  _vm._v(_vm._s(_vm.overview.monthCount) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("tin")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(_vm._s(_vm.monthLabel)),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "news-kpi-card border-amber" }, [
              _vm._m(4),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [
                  _vm._v("Trường đăng"),
                ]),
                _c("div", { staticClass: "kpi-number text-amber" }, [
                  _vm._v(_vm._s(_vm.overview.schoolMonthCount) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("tin")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(
                    _vm._s(_vm.overview.schoolMonthRate) + "% tổng tin tháng"
                  ),
                ]),
              ]),
            ]),
            _c("div", { staticClass: "news-kpi-card border-purple" }, [
              _vm._m(5),
              _c("div", { staticClass: "kpi-details" }, [
                _c("span", { staticClass: "kpi-name" }, [_vm._v("Lớp đăng")]),
                _c("div", { staticClass: "kpi-number text-purple" }, [
                  _vm._v(_vm._s(_vm.overview.classMonthCount) + " "),
                  _c("span", { staticClass: "kpi-unit" }, [_vm._v("tin")]),
                ]),
                _c("div", { staticClass: "kpi-hint" }, [
                  _vm._v(
                    _vm._s(_vm.overview.classMonthRate) + "% tổng tin tháng"
                  ),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "el-row",
        { staticClass: "news-content-row", attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 10, lg: 9 } }, [
            _c("div", { staticClass: "card-box h-100" }, [
              _c("div", { staticClass: "card-box-header" }, [
                _c("div", [
                  _c("h3", { staticClass: "box-title" }, [
                    _vm._v("Biểu Đồ Tin Tức Trong Tuần"),
                  ]),
                  _c("p", { staticClass: "box-subtitle" }, [
                    _vm._v("Tin đang hiển thị theo ngày tạo và cấp đăng"),
                  ]),
                ]),
                _vm.overview
                  ? _c("span", { staticClass: "tag-soft tag-soft--blue" }, [
                      _vm._v("Tuần này"),
                    ])
                  : _vm._e(),
              ]),
              _c("div", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingOverview,
                    expression: "loadingOverview",
                  },
                ],
                ref: "chartWeeklyNews",
                staticClass: "chart-wrapper",
              }),
              _vm.overview
                ? _c("div", { staticClass: "chart-legend-row" }, [
                    _c("div", { staticClass: "legend-chip" }, [
                      _c("span", { staticClass: "chip-color chip-school" }),
                      _c("span", [
                        _vm._v(
                          "Trường đăng (" +
                            _vm._s(_vm.overview.weeklySchoolTotal) +
                            " tin)"
                        ),
                      ]),
                    ]),
                    _c("div", { staticClass: "legend-chip" }, [
                      _c("span", { staticClass: "chip-color chip-class" }),
                      _c("span", [
                        _vm._v(
                          "Lớp đăng (" +
                            _vm._s(_vm.overview.weeklyClassTotal) +
                            " tin)"
                        ),
                      ]),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
          _c("el-col", { attrs: { xs: 24, sm: 24, md: 14, lg: 15 } }, [
            _c(
              "div",
              { staticClass: "card-box h-100" },
              [
                _c("div", { staticClass: "card-box-header" }, [
                  _c("div", [
                    _c("h3", { staticClass: "box-title" }, [
                      _vm._v("Danh Sách Tin Tức Mới Nhất"),
                    ]),
                    _c("p", { staticClass: "box-subtitle" }, [
                      _vm._v("10 tin được tạo gần nhất của trường"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "header-filter-action" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          staticClass: "compact-radio-group",
                          attrs: { size: "mini" },
                          on: { change: _vm.loadLatest },
                          model: {
                            value: _vm.filterScope,
                            callback: function ($$v) {
                              _vm.filterScope = $$v
                            },
                            expression: "filterScope",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "ALL" } }, [
                            _vm._v("Tất cả"),
                          ]),
                          _c(
                            "el-radio-button",
                            { attrs: { label: "SCHOOL" } },
                            [_vm._v("Cấp trường")]
                          ),
                          _c("el-radio-button", { attrs: { label: "CLASS" } }, [
                            _vm._v("Cấp lớp"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm.latestError
                  ? _c("el-alert", {
                      staticClass: "news-api-alert",
                      attrs: {
                        title: _vm.latestError,
                        type: "error",
                        "show-icon": "",
                        closable: false,
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loadingLatest,
                        expression: "loadingLatest",
                      },
                    ],
                    staticClass: "table-scroll-container",
                  },
                  [
                    _c(
                      "el-table",
                      {
                        staticClass: "compact-news-table",
                        attrs: {
                          data: _vm.latestNewsList,
                          size: "small",
                          stripe: "",
                          "empty-text": "Không có tin tức",
                          "header-cell-style": {
                            background: "#f1f5f9",
                            color: "#334155",
                            fontWeight: "700",
                            fontSize: "12px",
                          },
                          "max-height": "340",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            type: "index",
                            label: "STT",
                            width: "50",
                            align: "center",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Tiêu đề bài viết",
                            "min-width": "230",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "news-title-cell" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "news-title-text",
                                          attrs: { title: scope.row.title },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(scope.row.title) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Nguồn đăng",
                            width: "120",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "source-badge",
                                      class:
                                        scope.row.scope === "SCHOOL"
                                          ? "badge-school"
                                          : scope.row.scope === "CLASS"
                                          ? "badge-class"
                                          : "badge-unknown",
                                    },
                                    [
                                      _c("i", {
                                        class:
                                          scope.row.scope === "SCHOOL"
                                            ? "el-icon-office-building"
                                            : "el-icon-s-home",
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(scope.row.sourceName) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "Người tạo", width: "130" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [_vm._v(_vm._s(scope.row.author || "—"))]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Ngày tạo",
                            width: "125",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", { staticClass: "time-text" }, [
                                    _c("i", { staticClass: "el-icon-time" }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.formatCreatedDate(
                                            scope.row.createdDate
                                          )
                                        )
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "Trạng thái",
                            width: "105",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "status-tag",
                                      class:
                                        scope.row.status === "PUBLISHED"
                                          ? "status-approved"
                                          : "status-pending",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.statusLabel(scope.row.status)
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header-title-group" }, [
      _c("div", { staticClass: "header-icon-badge" }, [
        _c("i", { staticClass: "el-icon-reading" }),
      ]),
      _c("div", [
        _c("h2", { staticClass: "header-title" }, [
          _vm._v("Thống Kê Tin Tức & Bản Tin Học Đường"),
        ]),
        _c("p", { staticClass: "header-subtitle" }, [
          _vm._v(
            "Tin đang hiển thị theo ngày tạo, phân bổ cấp trường và cấp lớp"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-indigo-soft text-indigo" },
      [_c("i", { staticClass: "el-icon-date" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-icon-wrap bg-blue-soft text-blue" }, [
      _c("i", { staticClass: "el-icon-notebook-1" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "kpi-icon-wrap bg-teal-soft text-teal" }, [
      _c("i", { staticClass: "el-icon-files" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-amber-soft text-amber" },
      [_c("i", { staticClass: "el-icon-office-building" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "kpi-icon-wrap bg-purple-soft text-purple" },
      [_c("i", { staticClass: "el-icon-s-home" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }